import { render } from "./ActivosContrato.vue?vue&type=template&id=23e74a89"
import script from "./ActivosContrato.vue?vue&type=script&lang=js"
export * from "./ActivosContrato.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__